import styled from "@emotion/styled";
import { typography } from "@smartsheet/design-tokens";
import { tooltipTheme } from "../tooltipTheme";
/**
 * @deprecated Please use TooltipTitle inside a TooltipBody instead. This gives the Tooltip
 * component more flexibility in its composition.
 */
export const MultiLineTooltipTitleStyled = styled("div")`
    color: ${_ref => {
  let {
    themeMode
  } = _ref;
  return tooltipTheme.textColor.title(themeMode);
}};
    padding: ${_ref2 => {
  let {
    themeMode
  } = _ref2;
  return tooltipTheme.padding.multiLineDeprecated.title(themeMode);
}};

    // We have to manually apply these instead of using TypeRampV2 since these components are
    // directly exposed on the API and converting them to React components could cause a breaking
    // change.
    font-weight: ${typography.fontWeight.semiBold};
    font-size: ${_ref3 => {
  let {
    themeMode
  } = _ref3;
  return tooltipTheme.fontSize.multilineTitleDeprecated(themeMode);
}};
`;
/**
 * @deprecated Please use TooltipMultilineText inside a TooltipBody instead. This gives the Tooltip
 * component more flexibility in its composition.
 */
export const MultiLineTooltipSubtextStyled = styled("div")`
    padding: ${_ref4 => {
  let {
    themeMode
  } = _ref4;
  return tooltipTheme.padding.multiLineDeprecated.subtext(themeMode);
}};

    // All but the first subtext in the tooltip will need to shift a bit up. We wanted to use this
    // selector: ":not(<amp>:nth<dash>last-child(-n + 1 of &))" but it threw errors in jest. This
    // comment had to include that selector in a weird format because emotion's checker for SSR
    // apparently just checks string.contains and was throwing errors on the comment itself. We also
    // cannot use the :has selector since it's not supported in FF yet. The reason this is so tricky
    // is this component is trying to provide its own top and bottom padding to grow the container
    // at the bottom rather than relying on the container to provide the proper padding.
    & + & {
        margin-top: ${_ref5 => {
  let {
    themeMode
  } = _ref5;
  return tooltipTheme.padding.multiLineDeprecated.subtextShift(themeMode);
}};
    }
`;
//# sourceMappingURL=MultilineTooltipDeprecatedStyled.js.map